module.exports = __webpack_public_path__ + "assets/img/HighTechEnterprises.ff3841d0.png";